import { Box } from '@chakra-ui/react';
import React from 'react';
import { usePostContext } from '../PostContext';
import { IPostTitleProps } from './interfaces';
import { TitleText, Date } from './PostTitleStyled';
import formattedDate from '@helpers/formattedDate';

const PostTitle: React.FC<IPostTitleProps> = () => {
  const { post } = usePostContext();
  return (
    <Box mt="20px" mb="40px">
      <TitleText>{post?.title}</TitleText>
      <Date>{formattedDate(post?.date)}</Date>
    </Box>
  );
};

export default PostTitle;
